import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var EyeHideIcon = function EyeHideIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "EyeHideIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M1.487 1.487a.725.725 0 0 1 1.026 0l12 12a.725.725 0 0 1-1.026 1.026l-2.373-2.374c-.854.36-1.882.586-3.114.586-2.724 0-4.418-1.102-5.42-2.248a6.5 6.5 0 0 1-1.005-1.55 5.5 5.5 0 0 1-.272-.727L1.3 8.185l-.001-.005v-.002c-.001 0-.001-.002.702-.178l-.703-.177v-.002l.001-.003.002-.009.008-.026.024-.084a5 5 0 0 1 .099-.283 6.356 6.356 0 0 1 2.147-2.813l-2.09-2.09a.725.725 0 0 1 0-1.026m7.319 8.344 1.175 1.176A7 7 0 0 1 8 11.275c-2.276 0-3.582-.899-4.33-1.753A5 5 0 0 1 2.76 8l.025-.066a4.89 4.89 0 0 1 1.834-2.29l1.55 1.55a2 2 0 0 0 2.637 2.637",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "currentColor",
      d: "m2 8-.703.176L1.253 8l.044-.177z"
    }), jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 4.725c-.448 0-.856.035-1.229.096a.725.725 0 1 1-.236-1.43A9 9 0 0 1 8 3.274c2.723 0 4.418 1.101 5.42 2.247a6.5 6.5 0 0 1 1.005 1.55 5.5 5.5 0 0 1 .272.727l.004.016.001.005v.002c.001 0 .001.002-.702.178l.703.176v.004l-.002.006-.005.017a3 3 0 0 1-.07.226c-.05.145-.127.344-.239.578a6.5 6.5 0 0 1-1.157 1.678.725.725 0 0 1-1.047-1.002A5 5 0 0 0 13.239 8a5.006 5.006 0 0 0-.91-1.523C11.582 5.623 10.276 4.725 8 4.725",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "currentColor",
      d: "m14 8 .703-.176.044.176-.044.176z"
    })]
  }));
};

export { EyeHideIcon };
